import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grayBoxInfo" }
const _hoisted_2 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_3 = { class: "boxMessage loyaltyRewardsBox" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_loyalty-point absolute" }, null, -1)
const _hoisted_5 = { class: "eventCard" }
const _hoisted_6 = { class: "content pointsTransactionBox" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "actionValue" }
const _hoisted_11 = { class: "when" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfinityScroll = _resolveComponent("InfinityScroll")!

  return (_openBlock(), _createBlock(_component_InfinityScroll, {
    onLoadNextPage: _ctx.loadTransations,
    data: _ctx.transations.meta,
    loading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.transations.data && _ctx.transations.data.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t("global.no_data")), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transations.data, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            tabindex: "0"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.translateName(item)), 1),
                    (item.source)
                      ? (_openBlock(), _createElementBlock("br", _hoisted_7))
                      : _createCommentVNode("", true),
                    _createElementVNode("small", null, _toDisplayString(_ctx.translateDescription(item)), 1),
                    (item.reason)
                      ? (_openBlock(), _createElementBlock("br", _hoisted_8))
                      : _createCommentVNode("", true),
                    (item.reason)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.translateReason(item)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("strong", {
                      style: _normalizeStyle({ color: _ctx.getValueColors(item.change) })
                    }, _toDisplayString(_ctx.getValuePrefix(item.change)), 5),
                    _createElementVNode("span", {
                      class: "icon-warpit_icon_loyalty-point",
                      style: _normalizeStyle({ color: _ctx.getValueColors(item.change) })
                    }, null, 4)
                  ])
                ])
              ]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$moment(item.createdAt).format("DD.MM.YYYY HH:mm")), 1)
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["onLoadNextPage", "data", "loading"]))
}